module.exports = __webpack_public_path__ + "static/media/009-terrain.f94d8136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/009-terrain.png
// module id = 604
// module chunks = 0